import {Component} from '@angular/core';
import {MdChipInputEvent, ENTER} from '@angular/material';

const /** @type {?} */ COMMA = 188;
/**
 * \@title Chips with input
 */
export class ChipsInputExample {
  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = true;

  // Enter, comma
  separatorKeysCodes = [ENTER, COMMA];

  fruits = [
    { name: 'Lemon' },
    { name: 'Lime' },
    { name: 'Apple' },
  ];
/**
 * @param {?} event
 * @return {?}
 */
add(event: MdChipInputEvent): void {
    let /** @type {?} */ input = event.input;
    let /** @type {?} */ value = event.value;

    // Add our person
    if ((value || '').trim()) {
      this.fruits.push({ name: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }
/**
 * @param {?} fruit
 * @return {?}
 */
remove(fruit: any): void {
    let /** @type {?} */ index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'chips-input-example',
  templateUrl: 'chips-input-example.html',
  styleUrls: ['chips-input-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ChipsInputExample_tsickle_Closure_declarations() {
/** @type {?} */
ChipsInputExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ChipsInputExample.ctorParameters;
/** @type {?} */
ChipsInputExample.prototype.visible;
/** @type {?} */
ChipsInputExample.prototype.selectable;
/** @type {?} */
ChipsInputExample.prototype.removable;
/** @type {?} */
ChipsInputExample.prototype.addOnBlur;
/** @type {?} */
ChipsInputExample.prototype.separatorKeysCodes;
/** @type {?} */
ChipsInputExample.prototype.fruits;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
